/**
 * Everyday Comfort: калькулятор + стрілка скролу таблиці.
 * Inline <script> у секції видаляються при fetch у .size-chart-drawer — тому логіка тут.
 */
(function () {
  var UNDERBUST_BANDS = [
    { band: 70, min: 68, max: 72 },
    { band: 75, min: 73, max: 77 },
    { band: 80, min: 78, max: 82 },
    { band: 85, min: 83, max: 87 },
    { band: 90, min: 88, max: 92 },
    { band: 95, min: 93, max: 97 },
    { band: 100, min: 98, max: 102 },
    { band: 105, min: 103, max: 107 },
    { band: 110, min: 108, max: 112 },
    { band: 115, min: 113, max: 117 },
    { band: 120, min: 118, max: 122 }
  ];
  var CUP_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  function rangeFor(band, cupLetter) {
    var idx = CUP_LETTERS.indexOf(cupLetter);
    if (idx < 0) return null;
    var min = band + 12 + 2 * idx;
    var max = band + 14 + 2 * idx;
    return [min, max];
  }

  function inRange(v, min, max) { return v >= min && v <= max; }
  function bandFromUnderbust(u) {
    for (var i = 0; i < UNDERBUST_BANDS.length; i++) {
      var r = UNDERBUST_BANDS[i];
      if (inRange(u, r.min, r.max)) return r.band;
    }
    return null;
  }
  function cupFromOverbust(band, b) {
    for (var i = 0; i < CUP_LETTERS.length; i++) {
      var k = CUP_LETTERS[i];
      var r = rangeFor(band, k);
      if (!r) continue;
      if (inRange(b, r[0], r[1])) return k;
    }
    return null;
  }
  function rowKeyFromLetter(cupLetter, matrix) {
    matrix = matrix || {};
    if (matrix[cupLetter]) return cupLetter;
    if (cupLetter === 'E' && matrix['DD/E']) return 'DD/E';
    if ((cupLetter === 'F' || cupLetter === 'G' || cupLetter === 'H') && matrix['DDD/F']) return 'DDD/F';
    return cupLetter;
  }

  function bindScrollArrow(root) {
    var chartWrapper = root.querySelector('.ecsg-table-wrap .size-chart-wrapper');
    var scrollArrow = root.querySelector('.ecsg-table-wrap .scroll-arrow');
    if (!chartWrapper || !scrollArrow) return;
    if (scrollArrow.dataset.ecsgBound === '1') return;
    scrollArrow.dataset.ecsgBound = '1';
    var svgChevronRight =
      '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.8452 5.43475L22.8648 11.4545L23.6603 12.25L22.8648 13.0455L16.8452 19.0651L15.2541 17.4742L19.3532 13.3751H1.00049V11.1251H19.3535L15.2541 7.02574L16.8452 5.43475Z" fill="white"/></svg>';
    var svgChevronLeft =
      '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.9999 11.7H6.41394L11.7069 6.40704L10.2929 4.99304L2.58594 12.7L10.2929 20.407L11.7069 18.993L6.41394 13.7H20.9999V11.7Z" fill="white"/></svg>';
    function updateArrow() {
      var scrollLeft = chartWrapper.scrollLeft;
      var clientWidth = chartWrapper.clientWidth;
      var scrollWidth = chartWrapper.scrollWidth;
      if (scrollLeft + clientWidth < scrollWidth - 1) {
        scrollArrow.innerHTML = svgChevronRight;
        scrollArrow.style.right = '10px';
        scrollArrow.style.left = 'auto';
      } else {
        scrollArrow.innerHTML = svgChevronLeft;
        scrollArrow.style.left = '10px';
        scrollArrow.style.right = 'auto';
      }
    }
    updateArrow();
    chartWrapper.addEventListener('scroll', updateArrow);
    window.addEventListener('resize', updateArrow);
  }

  var SIZE_COLORS = {
    'S': '#DDEBF7', 'S+': '#FCE4D6',
    'M': '#FFF2CC', 'M+': '#FFE699',
    'L': '#FCE4EC', 'L+': '#E4D7F5',
    'XL': '#D9EAF7', 'XL+': '#B4C7E7',
    '2XL': '#E2F0D9', '2XL+': '#C6E0B4',
    '3XL': '#F8CBAD', '3XL+': '#F4CCCC',
    '4XL': '#E9C7D4', '4XL+': '#D4A8B8',
    '5XL': '#FFEB9C', '6XL': '#C8E6C9'
  };

  var SVG_ARROW_RIGHT = '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.8452 5.43475L22.8648 11.4545L23.6603 12.25L22.8648 13.0455L16.8452 19.0651L15.2541 17.4742L19.3532 13.3751H1.00049V11.1251H19.3535L15.2541 7.02574L16.8452 5.43475Z" fill="#2a555a"/></svg>';
  var SVG_ARROW_DOWN  = '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.707 13.407L17.293 11.993L13 16.286V6.70001H11V16.286L6.70697 11.993L5.29297 13.407L12 20.114L18.707 13.407Z" fill="#2a555a"/></svg>';

  // Dynamic sizing: uses underbust_ranges / cup_diffs from payload
  function bandFromRanges(u, ranges) {
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      if (inRange(u, r.min, r.max)) return r.band;
    }
    return null;
  }

  function cupFromDiffs(band, bust, diffs) {
    var diff = bust - Number(band);
    for (var i = 0; i < diffs.length; i++) {
      var d = diffs[i];
      if (inRange(diff, d.min, d.max)) return d.cup;
    }
    return null;
  }

  function renderTable(root, payload) {
    var placeholder = root.querySelector('.depns-table-js-root');
    if (!placeholder) return;
    var matrix = payload.matrix || {};
    var cups = payload.cups || Object.keys(matrix);
    var bands = payload.bands;
    if (!bands || !bands.length) {
      var firstCup = cups[0];
      bands = firstCup && matrix[firstCup] ? Object.keys(matrix[firstCup]) : [];
    }
    if (!cups.length || !bands.length) return;

    var html = '<div class="band-label"><div>Band</div>' + SVG_ARROW_RIGHT + '</div>';
    html += '<div class="size-chart-outer"><div class="size-chart-wrapper"><div class="size-chart-inner">';
    html += '<table class="size-chart-table"><thead><tr>';
    html += '<th class="cup-header"><div class="cup-label"><div>Cup</div>' + SVG_ARROW_DOWN + '</div></th>';
    for (var b = 0; b < bands.length; b++) { html += '<th>' + bands[b] + '</th>'; }
    html += '</tr></thead><tbody>';
    for (var c = 0; c < cups.length; c++) {
      var cup = cups[c];
      html += '<tr><td class="cup-size">' + cup + '</td>';
      for (var b2 = 0; b2 < bands.length; b2++) {
        var val = (matrix[cup] && matrix[cup][String(bands[b2])] != null) ? String(matrix[cup][String(bands[b2])]).trim() : '';
        var bg = SIZE_COLORS[val] || 'transparent';
        html += val ? '<td style="background-color:' + bg + '">' + val + '</td>' : '<td></td>';
      }
      html += '</tr>';
    }
    html += '</tbody></table></div></div><div class="scroll-arrow" aria-hidden="true"></div></div>';
    placeholder.innerHTML = html;
  }

  function initEcsgRoot(root) {
    if (!root || root.getAttribute('data-ecsg-done') === '1') return;
    var ta = root.querySelector('textarea.ecsg-payload-json');
    if (!ta) { root.setAttribute('data-ecsg-done', '1'); return; }
    var payload;
    try { payload = JSON.parse(ta.value); } catch (e) { root.setAttribute('data-ecsg-done', '1'); return; }
    renderTable(root, payload);
    bindScrollArrow(root);
    var matrix = payload.matrix || {};
    var outputMode = root.getAttribute('data-output-mode') || payload.output || 'bra';

    var stepsRoot = root.querySelector('.ecsg-steps[data-size-steps]');
    if (!stepsRoot || stepsRoot.getAttribute('data-ecsg-calc-inited') === '1') {
      root.setAttribute('data-ecsg-done', '1'); return;
    }

    var st1 = stepsRoot.querySelector('[data-step="1"]');
    var st2 = stepsRoot.querySelector('[data-step="2"]');
    var st3 = stepsRoot.querySelector('[data-step="3"]');
    var underbustInput = st1 && st1.querySelector('[data-field="underbust"]');
    var bustInput = st2 && st2.querySelector('[data-field="bust"]');
    var next1 = st1 && st1.querySelector('[data-action="next"]');
    var calc2 = st2 && st2.querySelector('[data-action="calc"]');
    var outSize = st3 && st3.querySelector('[data-out="size"]');
    var restart = st3 && st3.querySelector('[data-action="restart"]');
    if (!underbustInput || !bustInput || !next1 || !calc2 || !outSize || !restart) {
      root.setAttribute('data-ecsg-done', '1'); return;
    }

    // Choose sizing functions: payload ranges override EU defaults
    var _bandFn = payload.underbust_ranges
      ? function (u) { return bandFromRanges(u, payload.underbust_ranges); }
      : bandFromUnderbust;
    var _cupFn = payload.cup_diffs
      ? function (band, bust) { return cupFromDiffs(band, bust, payload.cup_diffs); }
      : cupFromOverbust;

    // Sync input min/max/placeholder from payload ranges
    var unitLabel = payload.unit === 'in' ? 'in' : 'cm';
    if (payload.underbust_ranges && payload.underbust_ranges.length) {
      var ubMins = payload.underbust_ranges.map(function (r) { return r.min; });
      var ubMaxs = payload.underbust_ranges.map(function (r) { return r.max; });
      underbustInput.min  = Math.min.apply(null, ubMins);
      underbustInput.max  = Math.max.apply(null, ubMaxs);
      underbustInput.placeholder = 'Underbust (' + unitLabel + ')';
    }
    if (payload.cup_diffs && payload.cup_diffs.length && payload.underbust_ranges) {
      var allBands  = payload.underbust_ranges.map(function (r) { return Number(r.band); });
      var diffMins  = payload.cup_diffs.map(function (d) { return d.min; });
      var diffMaxs  = payload.cup_diffs.map(function (d) { return d.max; });
      bustInput.min  = Math.floor(Math.min.apply(null, allBands) + Math.min.apply(null, diffMins));
      bustInput.max  = Math.ceil( Math.max.apply(null, allBands) + Math.max.apply(null, diffMaxs));
      bustInput.placeholder = 'Bust (' + unitLabel + ')';
    }

    function show(stepEl) { st1.hidden = true; st2.hidden = true; st3.hidden = true; stepEl.hidden = false; }
    function getBand() { return _bandFn(Number(underbustInput.value)); }
    function getMappedSize() {
      var band = getBand(); if (!band) return '';
      var cupLetter = _cupFn(band, Number(bustInput.value)); if (!cupLetter) return '';
      if (cupLetter === 'A') return '';
      var rowKey = rowKeyFromLetter(cupLetter, matrix);
      var val = matrix[rowKey] && matrix[rowKey][String(band)] != null ? String(matrix[rowKey][String(band)]).trim() : '';
      return val;
    }

    function calc() {
      var band = getBand();
      if (!band) { alert('Measurement is outside the table range.'); return; }
      var cupLetter = _cupFn(band, Number(bustInput.value));
      if (!cupLetter) { alert('Bust measurement does not match this band size.'); return; }
      if (cupLetter === 'A') { alert('Cup A is not listed in this table.'); return; }
      var rowKey = rowKeyFromLetter(cupLetter, matrix);
      var mapped = matrix[rowKey] && matrix[rowKey][String(band)] != null ? String(matrix[rowKey][String(band)]).trim() : '';
      if (!mapped) { alert('No result found for this combination.'); return; }
      outSize.textContent = outputMode === 'mapped' ? mapped : String(band) + cupLetter;
      show(st3);
    }

    underbustInput.addEventListener('input', function () { next1.disabled = !getBand(); });
    bustInput.addEventListener('input', function () { calc2.disabled = !getMappedSize(); });
    underbustInput.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !next1.disabled) { e.preventDefault(); show(st2); } });
    bustInput.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !calc2.disabled) { e.preventDefault(); calc(); } });
    next1.addEventListener('click', function () { show(st2); });
    calc2.addEventListener('click', calc);
    restart.addEventListener('click', function () {
      underbustInput.value = ''; bustInput.value = '';
      next1.disabled = true; calc2.disabled = true;
      outSize.textContent = '—'; show(st1);
    });

    stepsRoot.setAttribute('data-ecsg-calc-inited', '1');
    root.setAttribute('data-ecsg-done', '1');
  }

  window.initEcsgRoots = function (scope) {
    scope = scope || document;
    var roots = scope.querySelectorAll ? scope.querySelectorAll('.ecsg-root') : [];
    for (var i = 0; i < roots.length; i++) { initEcsgRoot(roots[i]); }
  };

  function boot() { if (typeof window.initEcsgRoots === 'function') window.initEcsgRoots(document); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
